import * as types from './types'

export default {
  [types.NEW_DISCOUNT_COUPON_SIDEBAR]: state => {
    return state.newDiscountCouponSidebar
  },
  [types.DISCOUNT_COUPONS_SEARCH_RESULT]: state => {
    return state.discountCouponsSearchResult
  },
}
